import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './components/app';
import HomeIndex from './components/index_home';
import UserLogin from './components/user/login';
import UserRegister from './components/user/register';
import UserProfile from './components/user/profile';
import Itinerary from './containers/itinerary/itinerary';
import Journal from './containers/journal/journal';
import JournalSingle from './containers/journal/journalSingle';
import Editor from './containers/editor/editor';
import Checkin from './containers/checkin/checkin';
import ResetPassword from './components/user/reset_password';
import requireAuth from './utils/authenticated';
import { composeEnterHooksSeries } from './utils/composeHooks';
import collapseNav from './utils/collapseNav';

export default (
    <Route path="/" component={ App }>
        <IndexRoute component={ HomeIndex } onEnter={ collapseNav } />
        <Route path="/login" component={ UserLogin } onEnter={ collapseNav } />
        <Route path="/register" component={ UserRegister } onEnter={ collapseNav } />
        <Route path="/reset" component={ ResetPassword } onEnter={ collapseNav } />
        <Route path="/profile" component={ UserProfile } onEnter={ composeEnterHooksSeries(requireAuth, collapseNav) } />
        <Route path="/itinerary" component={ Itinerary } onEnter={ collapseNav } />
        <Route path="/journal" component={ Journal } onEnter={ collapseNav } />
        <Route path="/journal/:id" component={ JournalSingle } onEnter={ collapseNav } />
        <Route path="/edit" component={ Editor} onEnter={ composeEnterHooksSeries(requireAuth, collapseNav) } />
        <Route path="/checkin" component={ Checkin} onEnter={ composeEnterHooksSeries(requireAuth, collapseNav) } />
        <Route path="/checkin" component={ Checkin } onEnter={ composeEnterHooksSeries(requireAuth, collapseNav) } />
        <Route path="/checkin/:id" component={ Checkin } onEnter={ composeEnterHooksSeries(requireAuth, collapseNav) } />
    </Route>
);


// WEBPACK FOOTER //
// ./src/app/routes.js